import {
  EDisplayName,
  EFieldsName,
  IDataPreference
} from "@/features/financas/views/Indicadores/@types/type";
import { IConciliacaoStrategy } from "../preferenciasInterfaces";
import { EWidgets } from "@/features/financas/views/Indicadores/@types/enums";
import Preferencia from "../Preferencia";

export default class ConcialiacaoStrategy implements IConciliacaoStrategy {
  createCompanies(companies: string[]): IDataPreference<string[] | string> {
    const preferencia = new Preferencia({
      fieldName: EFieldsName.empresas,
      fieldData: companies.join(","),
      displayName: EDisplayName.cardConciliacao,
      id: EWidgets.CardConciliacao
    });

    return preferencia.createPreferencesData();
  }

  createRangeInicio(filtro: string): IDataPreference<string> {
    const periodoInicio = new Preferencia({
      fieldName: EFieldsName.periodoInicio,
      fieldData: filtro[0],
      displayName: EDisplayName.cardConciliacao,
      id: EWidgets.CardConciliacao
    });

    return periodoInicio.createPreferencesData();
  }

  createRangeFim(filtro: string): IDataPreference<string> {
    const periodoFim = new Preferencia({
      fieldName: EFieldsName.periodoFim,
      fieldData: filtro[1],
      displayName: EDisplayName.cardConciliacao,
      id: EWidgets.CardConciliacao
    });

    return periodoFim.createPreferencesData();
  }
}
